import classnames from 'classnames';
import React from 'react';

import {Text} from '@albert-io/atomic';

import {HIGHLIGHT_BACKGROUND_CLASS} from './annotationHighlightStyles';
import type {TextAnnotation} from './annotationTypes';

interface AnnotationNoteListProps {
  /** Text marks that carry a note, in document order; each is quoted by its anchor text. */
  annotations: TextAnnotation[];
}

/**
 * Each note under the text it was written about. An underlined mark is quoted
 * underlined rather than filled, since it has no fill of its own to restate.
 */
export default function AnnotationNoteList({annotations}: AnnotationNoteListProps) {
  return (
    <ul className='m-x0 gap-x2 p-x0 flex list-none flex-col'>
      {annotations.map(({id, anchor, note, color, type}) => (
        <li key={id} className='gap-x1 flex flex-col'>
          <Text
            size='s'
            className={classnames('rounded-x1 px-x1 py-x0-half leading-[1.4] wrap-break-word', {
              [HIGHLIGHT_BACKGROUND_CLASS[color]]: type === 'highlight',
              underline: type === 'underline'
            })}
          >
            {`“${anchor.exact}”`}
          </Text>
          {/* Notes merged from combined marks are newline-separated (annotationMerge). */}
          <Text size='s' className='leading-[1.4] wrap-break-word whitespace-pre-wrap'>
            {note}
          </Text>
        </li>
      ))}
    </ul>
  );
}
